<template>
  <v-row
    v-if="isBranch && !chapterSalesAccessChecked"
    justify="center"
    class="my-0 py-12"
  >
    <v-col cols="11" sm="8" md="6">
      <v-progress-linear color="primary" indeterminate rounded height="6" />
    </v-col>
  </v-row>
  <v-row v-else justify="center" class="my-0 py-4">
    <v-col cols="11" class="white rounded-xl">
      <v-tabs :color="color.primaryVariant" v-model="tab">
        <v-tab v-if="showMembershipAdmin" href="#membership-admin">
          <span class="wc-caption-1">Administrar Membresías</span>
        </v-tab>
        <v-tab href="#members">
          <span class="wc-caption-1">Miembros</span>
        </v-tab>
        <v-tab
          v-if="user.role == 'HEAD_OFFICE' || isAmpiFullAccess"
          href="#registration"
        >
          <span class="wc-caption-1">Formulario de Registro</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item v-if="showMembershipAdmin" value="membership-admin">
          <Affiliations></Affiliations>
        </v-tab-item>

        <v-tab-item value="members">
          <Members></Members>
        </v-tab-item>

        <v-tab-item
          v-if="user.role == 'HEAD_OFFICE' || isAmpiFullAccess"
          value="registration"
        >
          <Registration></Registration>
        </v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
import Chat from '@/components/shared/Chat.vue';

import { colors } from '@/constants/colors';
import Affiliations from '../Affiliations.vue';
import Members from '../Members/index.vue';
import Registration from '../Registration.vue';
import { mapState } from 'vuex';
import { isAmpiOrganizationUser } from '@/common/ampiOrganizationUserAccess';

export default {
  name: 'MyMembers',
  components: {
    Members,
    Affiliations,
    Registration,
    Chat,
  },
  data() {
    return {
      color: colors,
      tab: 'members',
      branchMembershipMode: null,
      chapterSalesAccessChecked: false,
    };
  },
  computed: {
    ...mapState('user', ['user']),
    isAmpiFullAccess() {
      return isAmpiOrganizationUser(this.user);
    },
    isBranch() {
      return this.user?.role === 'BRANCH';
    },
    showMembershipAdmin() {
      return !this.isBranch || Boolean(this.branchMembershipMode);
    },
  },
  async created() {
    if (!this.isBranch) {
      this.tab = 'membership-admin';
      this.chapterSalesAccessChecked = true;
      return;
    }

    try {
      const { data } = await this.axios.get('/affiliations/branch-memberships');
      this.branchMembershipMode = data?.mode || null;
    } catch (error) {
      this.branchMembershipMode = null;
    } finally {
      this.tab = this.showMembershipAdmin ? 'membership-admin' : 'members';
      this.chapterSalesAccessChecked = true;
    }
  },
};
</script>

<style></style>
